export const LOAD_TAG_LIST = 'LOAD_TAG_LIST';
export const SET_TAG_LIST_LOADING_STATUS = 'SET_TAG_LIST_LOADING_STATUS';
export const SET_TAG_ACTION_LOADING_STATUS = 'SET_TAG_ACTION_LOADING_STATUS';
